import styled, { css } from "styled-components";
import { Paragraph2, WrapperContainer } from "../../../../../components";
import { colors } from "../../../../../consts";
import { FormSectionWrapper } from "../../../../../templates/FormSection/styled";
import { RadioInputLabel } from "../../../../../components/RadioGroup/styled";
import { RadioInputWrapper } from "../../../../../components/RadioOptionsSelector/styled";
import { InputComponentWrapper } from "../../../../../components/Input/styled";

export const Title = styled(Paragraph2)`
  font-weight: 600;
  color: ${colors.RAISIN_70};
`;

export const IconWrapper = styled(WrapperContainer)`
  svg {
    path {
      stroke: ${colors.RAISIN_70};
      transition: stroke 0.3s;
    }
  }
`;

const ReleaseNoteActiveStyles = css`
  ${Title} {
    color: ${colors.RAISIN_100};
  }

  ${IconWrapper} {
    svg {
      path {
        stroke: ${colors.RAISIN_100};
      }
    }
  }
`;

export const ReleaseNoteOptionWrapper = styled(WrapperContainer)`
  cursor: pointer;

  ${(props) => props?.isActive && ReleaseNoteActiveStyles}
`;

export const ReleaseNotesFormSection = styled(WrapperContainer)`
  ${FormSectionWrapper} {
    padding: 20px 0 0 0;

    > div:first-child {
      padding: 0 24px;
    }
  }
`;

export const ReleaseNotesSelectorWrapper = styled(WrapperContainer)`
  > div {
    flex-direction: row;
    align-items: center !important;
  }

  ${RadioInputWrapper} {
    padding: 4px;
    padding-left: 16px;
    padding-right: 6px;
  }

  ${RadioInputLabel} {
    width: 100%;
  }
`;

export const OptionsInfoWrapper = styled(WrapperContainer)`
  ${Paragraph2} {
    color: ${colors.WHITE};
  }
`;

const SelectedOptionStyles = css`
  svg {
    path {
      stroke: ${colors.WHITE} !important;
    }
  }
`;

export const OptionComponent = styled(WrapperContainer)`
  ${(props) => props?.isSelected && SelectedOptionStyles}
`;

export const RichReleaseNotesDropdownContainer = styled(WrapperContainer)`
  ${InputComponentWrapper} {
    height: 40px;
    min-height: 40px;

    padding-top: 6px;
    padding-bottom: 6px;

    ${OptionComponent} {
      svg {
        path {
          stroke: ${colors.RAISIN_100} !important;
        }
      }
    }
  }
`;
